import React from 'react'
import _ from 'lodash'
import { Button, ConfigProvider, Tooltip } from 'antd'
import { connect } from "react-redux"

import CoreRenderFunction from 'DisplayCore'
import { applyColor } from 'utils/apply-color'
import { checkIfComponentDisabled, getContraColor } from 'utils'
import './index.scss'

const TechBaseButton = props => {
  const { enabled = true } = props;
  let {
    href,
    size,
    style,
    shape,
    children,
    className,
    htmlType,
    buttonType,
    variant,
    actionKey,
    param,
    isActiveKey,
    activeStyle,
    isDisabled,
    danger,
    target
  } = props.item

  const checkIsDisabled = () => {
    if( isDisabled ) {
      return checkIfComponentDisabled( props.disabledComponent, props.item )
    }
    return false
  }

  const conditionalStyle = enabled ? {
    border: '1px solid $primary',
    backgroundColor: '#ffffff',
    color: '$primary',
    boxShadow: '0 2px 8px $primary-shadow',
  } : {
    border: '1px solid #d9d9d9',
    backgroundColor: '#f0f0f0',
    color: '#595959',
    boxShadow: 'none',
  };

  const finalStyle = applyColor({
    ...style,
    ...conditionalStyle,
    ...(isActiveKey && props[isActiveKey] === true && !_.isEmpty(activeStyle) ? activeStyle : {})
  }, props.colors);


  return(
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: props.colors.primary
        },
      }}
    >
      <Button
        size={ size }
        danger={ danger }
        htmlType={ htmlType }
        type={ buttonType }
        variant={ variant }
        target={ target }
        style={finalStyle}
        className={ className }
        shape={ shape }
        href={ href }
        onClick={ () => {
          if ( typeof props.onClickAction === 'function' ) {
            props.onClickAction( actionKey, ...( param ? param.map( val => props[ val ] || val ) : [] ) )
          }
        }}
        disabled={ checkIsDisabled() }
      >
        {
          children?.map( child => {
            if (child.type === 'tooltip') {
              return (
                <Tooltip title={child.content}>
                  {child.children?.map(tooltipChild => <CoreRenderFunction {...props} item={tooltipChild} />)}
                </Tooltip>
              )
            } else {
              return <CoreRenderFunction {...props} item={ child } />
            }
          })
        }
      </Button>
    </ConfigProvider>
  )
}

const mapStateToProps = state => ({
  colors: state.ClientReducer.clientInfo.styles?.colors
})

export default connect( mapStateToProps )( TechBaseButton )